// biome-ignore lint/style/noRestrictedImports: Used to create our custom Image component
import { default as NextImage, type ImageProps as NextImageProps } from 'next/image';
import { AnalyticsEvent } from '@/app_lib/types/analytics';
import { cn } from '@/app_lib/utils/utils';

const dataBlur =
  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAIAA8DASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAhEAACAQIGAwAAAAAAAAAAAAABAgMABAUGESExQVFhcf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AmzHMVs7vSyWcdxKj28bSsqEkKSQPPFFFAikn5P/Z';

export interface ImageProps extends Omit<NextImageProps, 'placeholder'> {
  sources?: {
    srcSet: string;
    type: string;
  }[];
  quality?: number;
  blurDataUrl?: string;
  className?: string;
  pictureClassName?: string;
  fullWidth?: boolean;
}

// TODO: Consider setting the default loading behavior to 'lazy' for performance optimization
// TODO: Make sure this component was made correctly
export const Image = ({
  src,
  alt,
  width,
  height,
  blurDataUrl = dataBlur,
  className,
  pictureClassName,
  quality = 75,
  fullWidth = true,
  ...props
}: ImageProps) => {
  const defaultQuality = 75;

  return (
    <picture className={cn(`block ${fullWidth ? 'w-full' : ''}`, pictureClassName)}>
      <NextImage
        alt={alt}
        blurDataURL={blurDataUrl}
        className={cn('transition-opacity duration-300', className, AnalyticsEvent.ImpressionElement)}
        height={height}
        placeholder='blur'
        quality={quality || defaultQuality}
        sizes={
          fullWidth
            ? '(max-width: 320px) 50vw, (max-width: 768px) 85vw, (max-width: 1024px) 50vw, (max-width: 1200px) 40vw, 33vw'
            : ''
        }
        src={src || '/placeholder.svg'}
        width={width}
        {...props}
      />
    </picture>
  );
};
